export * from './delete-erforderliches-dokument-request.interface';
export * from './delete-erforderliches-dokument-response.interface';
export * from './delete-erforderliches-dokument.shapes';
